const messageKeys = [
  'searchbox.button.search',
  'datedSearchModal.modal.button.search',
  'datedSearchModal.modal.title',
  'datedSearchModal.modal.subheading',
  'datedSearchModal.modal.no.dates.message',

  'searchbox.datepicker.input.label.checkin',
  'searchbox.datepicker.input.label.checkout',
  'searchbox.datepicker.input.label.dates',
  'searchbox.datepicker.link.clear',
  'searchbox.datepicker.modal.button.done',

  'searchbox.guests.input.label',
  'searchbox.guests.selector.adult',
  'searchbox.guests.selector.adults',
  'searchbox.guests.selector.child',
  'searchbox.guests.selector.children',
  'searchbox.guests.selector.pets',
  'searchbox.guests.input.guest',
  'searchbox.guests.input.guests',
  'searchbox.guests.selector.pets.yes',
  'searchbox.guests.selector.pets.no',
  'searchbox.guests.selector.button.apply',
  'searchbox.guests.modal.title',
  'searchbox.guests.modal.button.continue',
  'searchbox.guests.pets.message',

  'datedSearchModal.modal.no.dates'
];

const getLabels = (
  mobileTitle,
  buttonTitle,
  modalTitle,
  modalSubtitle,
  modalDefaultErrorMsg,

  checkIn,
  checkOut,
  dates,
  labels,
  done,

  label,
  adult,
  adults,
  child,
  children,
  pets,
  guest,
  guests,
  yesBtn,
  noBtn,
  applyBtn,
  modalGuestPickerTitle,
  mobileBtn,
  petMessage,

  checkboxLabel
) => ({
  mobileTitle,
  buttonTitle,
  modalTitle,
  modalSubtitle,
  modalDefaultErrorMsg,
  datePickerLabels: {
    checkIn,
    checkOut,
    dates,
    labels,
    done
  },
  guestsLabels: {
    label,
    adult,
    adults,
    child,
    children,
    pets,
    guest,
    guests,
    yesBtn,
    noBtn,
    applyBtn,
    modalGuestPickerTitle,
    mobileBtn,
    petMessage
  },
  checkboxLabel
});

export {
  messageKeys,
  getLabels
};
